import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TechRadarFilters {
  domain?: string;
  system?: string;
}

interface TechRadarFilterContextType {
  filters: TechRadarFilters;
  setFilters: (filters: TechRadarFilters) => void;
}

const TechRadarFilterContext = createContext<
  TechRadarFilterContextType | undefined
>(undefined);

export const TechRadarFilterProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [filters, setFilters] = useState<TechRadarFilters>({});

  return (
    <TechRadarFilterContext.Provider value={{ filters, setFilters }}>
      {children}
    </TechRadarFilterContext.Provider>
  );
};

export const useTechRadarFilters = (): TechRadarFilterContextType => {
  const context = useContext(TechRadarFilterContext);
  if (!context) {
    return { filters: {}, setFilters: () => {} };
  }
  return context;
};

// Singleton for API access (since API is created outside React)
let globalFilters: TechRadarFilters = {};

export const setGlobalTechRadarFilters = (filters: TechRadarFilters) => {
  globalFilters = filters;
};

export const getGlobalTechRadarFilters = (): TechRadarFilters => {
  return globalFilters;
};
